import React, { useState, useEffect, useRef } from "react";
import {
  Grid,
  TextField,
  Autocomplete,
  Typography,
  Backdrop,
  CircularProgress,
  IconButton,
  Button,
  Box,
} from "@material-ui/core";
import Card from "../../../StyledComponents/Card/Card";
import CardHeader from "../../../StyledComponents/Card/CardHeader";
import CardText from "../../../StyledComponents/Card/CardText";
import CardBody from "../../../StyledComponents/Card/CardBody";
import { makeStyles } from "@material-ui/styles";
import VendorTaxTable from "../NewInvoice/Tables/Vendor_Tax_Detail";
import { ArrowBack, Error } from "@material-ui/icons";
import PODetail from "../NewInvoice/Tables/PoDetail_Table";
import ExpenseDetail from "../NewInvoice/Tables/ExpenseDetail.js";

import FER_Fuel_General_Allowance from "../NewInvoice/Tables/FERTables/FER_Fuel_General_Allowance.js";
import FER_General from "../NewInvoice/Tables/FERTables/FER_General.js";
import FER_Allowance from "../NewInvoice/Tables/FERTables/FER_Allowance.js";

import {
  clearState,
  getCommentsByInvoiceId,
  getCommentsByERFInvoiceNo,
  getCommentsByARFInvoiceNo ,
  getInvoiceByInvoiceIdAndRoleId,
  getVendorByPO,
  updateIPInvoice,
  getAllInvoiceDetailByInvoiceId,
  vendorTaxDetailForCnic,
  changeInvoiceStatus,
  ChangeInvoiceStatus_V1,
  getRefrenceDataList,
  getImportPoData,
  updateIPInvoiceByImport,
  uploadAdditioalDocumentFile,
  uploadFile,
  getVendorDetail,
  uploadFile_v1,
  getAllRefrenceDataList,
  getVendorForPaymentMethod,
  getMethodForPageRefresh,
} from "../actions";
import InvoiceGuideLine from "../NewInvoice/InvoiceGuidLines/InvoiceGuideLine";
import CustomSnackbar from "../../../CustomSnackbar";
import moment from "moment";
import { dashboardStyle } from "../Components/InvoiceDetails/style";
// import { demandType, category, invoiceType } from "../../Home/constant";
import InvoiceCheckboxes from "../Components/InvoiceDetails/InvoiceCheckboxes";
import InvoiceRadioButtons from "../Components/InvoiceDetails/InvoiceRadiobuttons";
import InvoiceTextField from "../Components/InvoiceDetails/InvoiceTextFields";
// import  from "../Components/PaymentDetails/PaymentDetail";
import PaymentDetail from "../Components/PaymentDetails/PaymentDetail.js";
import TaxDetail from "../Components/TaxDetails/TaxDetails";
import { useNavigate, useLocation } from "react-router-dom";
import { getUserRoles } from "../../Home/actions";
import getParameterByName, {
  convertToFloat,
} from "../../../Functions/functions";
// import TaxTable_Short from "../NewInvoice/Tables/Tax_Table_Short";
import GL_Table_ProcessInvoice from "../NewInvoice/Tables/GL_Table_ProcessInvoice";
import GL_Table_ProcessInvoiceV2 from "../NewInvoice/Tables/GL_Table_ProcessInvoice_V2.js";
import ConfirmationModal from "../../../components/ConfirmModal/ConfirmationModal";
import AttachmentsCover from "../../../components/Attachments/AttachmentsCover";
import { addZeroes } from "../../../Functions";
import OldDateWarning from "../NewInvoice/InvoiceGuidLines/OldDateWarning";
// import TaxTable_Short_Import from "../NewInvoice/Tables/Tax_Table_Short_import";
import PoDetail_Table_Import from "../NewInvoice/Tables/PoDetail_Table_Import";
import Po_ImportReference_Table from "../NewInvoice/Tables/Po_ImportReference_Table";
import Vendor_Table from "../NewInvoice/Tables/Vendor_Table";
import PaymentImport from "../NewInvoice/Payment/PaymentImport";
import WarningBox from "../Components/WarningBox";
import ExpenseTable from "../NewInvoice/Tables/ExpenseTable";
import Heading from "../../../StyledComponents/Heading/Heading";
import CommentHistory from "../NewInvoice/Tables/CommentHistory";
// import { proces } from "../actions";
import TaxTable from "../NewInvoice/Tables/Tax_Table";
import GLAccountHistory from "../NewInvoice/Tables/GL_AccountHistory";
import POAlertDialog from "../NewInvoice/Tables/PoTableAlert";
import Spinner from "../../Spinner/Spinnerv2";
import GL_Table from "../NewInvoice/Tables/GL_Table";
import jwt from "jsonwebtoken";
import TaxTableV2 from "../NewInvoice/Tables/TaxTableV2.jsx";
import { getAllInvoiceDetailByInvoiceIdV2 } from "./actions.js";
import { vendorTaxDetailV2 } from "../NewInvoice/Tables/taxActions.js";
import GL_Table_HR_ProcessInvoiceV2 from "../NewInvoice/Tables/GL_Table_HR_ProcessInvoice_V2.js";
import PageNotFound from "../NewInvoice/PageNotFound.js";
import ExpenseDetailTable from "../NewInvoice/Tables/ExpenseDetailTable.js";
import TaxTeamModal from "../Components/Modals/TaxTeamModal.js";
import ReviewerModal from "../Components/Modals/ReviewerModal.js";
import GL_Table_V2 from "../NewInvoice/Tables/GL_Table_V2";
import DepartmentCoordinatorRent from "../DepartmentCoordinator/DepartmentCoordinatorRent";
import RTBLineItems_Table from "../NewInvoice/Tables/RTBLineItems_Table";
const token = localStorage.getItem("user_token");
const user = jwt.decode(token);

const useStyles = makeStyles(dashboardStyle);

const ProcessInvoice = () => {
  const classes = useStyles();

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    setTimeout(() => {
      if (location?.state?.msg) {
        setSuccessMessage(location?.state?.msg);
        navigate(
          {
            pathname: location.pathname,
            search: location.search,
          },
          { replace: true }
        );
      }
    }, 2000);
  }, []);
  const invoiceId = getParameterByName("invoiceId");
  const roleId = getParameterByName("roleId");
  const roleName = getParameterByName("roleName");
  const vendorCode = getParameterByName("vendorCode");
  const edit = getParameterByName("edit");
  const status = getParameterByName("status");
  const [openTaxModal, setOpenTaxModal] = useState(false);
  const [reviewerModal,setReviewerModal]=useState(false)
  const [reviewer,setReviewer]=useState('')
  const invoicePayload = {
    Invoice_id: invoiceId,
    Vendor_Code: vendorCode,
  };

  const role = {
    roleId: roleId,
    roleName: roleName,
  };

  const [selectedRole, setSelectedRole] = useState(
    role ? { roleName: role?.roleName } : ""
  );

  const [poBasedState, setPoBasedState] = useState("PO");
  const [physicalOrEInvoice, setPhysicalOrEInvoice] = useState("Physical");
  const [attachInvoiceLoading, setAttachInvoiceLoading] = useState(false);
  const [roles, setRoles] = useState([]);
  const [rolesLoading, setRolesLoading] = useState(false);

  const [openInvoiceGuideLine, setOpenInvoiceGuideLine] = useState(false);

  const [confirmationModal, setConfirmationModal] = useState(false);
  const [confirmationMessage, setConfirmationMessage] = useState("");
  const [statusForPayload, setStatusForPayload] = useState("");

  const [commentsList, setCommentsList] = useState([]);
  const [commentsLoading, setCommentsLoading] = useState(false);
  const errorMessageRef = useRef(null);
  const [ErrorMessageForAmount, setErrorMessageForAmount] = useState("");
  const [POImportReference_Table, setPOImportReference_Table] = useState([]);
  const [PO_InvoiceAmountforTax, setPO_InvoiceAmountforTax] = useState("");
  // const [isLoading, setIsLoading] = useState(true);
  const [multipleData, setMultipleData] = useState({
    sglInd: [],
    tType: [],
    glAccount: [],
    postingKey: [],
    paymentDetail: [],
    paymentMethod: [],
    paymentTerms: [],
    paymentMethSupp: [],
    poData: [],
    vendorTaxDetail: [],
    currency: [],
    invoice_Type: [],
    document_Type: [],
    invoice_Details: [],
    efdv_Invoices: [],
    erf_ExpenseInvoice_Detail: [],
    fer_Invoice_Detial: [],
  });
  const invoice_attachmentRef = useRef(null);
  const additionalAttachmentRef = useRef(null);
  const [formState, setFormState] = useState({
    delv_Note_No: "",
    daysto_sale_taxlapse: "",
    courier_Company: "",
    courier_Tracking_No: "",
    created_On: new Date(),
    updated_By: "",
    updated_On: new Date(),
    comments: "",
    aditional_Comments: "",
    file_name: "",
    quantity: "",
    charge_Account: "",
    cost_Center: "",
    asset_No: "",
    plant_Code: "",
    dept_coordinator: "",
    loam_approver: "",
    buyer: "",
    prInitiator: "",
    taxTeam: "",
    paymentTerm: "",
    invoiceDocURL: "",
    isSubmittedByVendor: true,
    supervisorLevel: "",
    sodReviewer: "",
    dcReviewer: "",
    loamReviewer: "",
    supervisorReviewer: "",
    logisticsTeam: "",
    logisticsReviewer: "",
    reviewer1: "",
    reviewer2: "",
    pcdvSegment: "",
    pcdvLocation: "",
    invoiceLocation: "",
    employeeCode: "",
    vP_InvoiceId: 0,
    po_Date: "",
    plant_Code : "",
    isInitiator: false,
    isDeptCordinator: false,
    isHR: false,
    isPCDV: false, // EFDV initiator
    isVPPayment: false,
    isVFPayment: false,
    isSubmittedByVendor: false,
    isImport: false,
    isLogistics: false,
    submission_Date: new Date(),
    // adjustAdvance : false,
    // submission_Date: moment().format("YYYY-MM-DD"),
    pO_Based: true,
    isPSID: false,
    psid: "",
    urgent: false,
    skipTaxStep: false,
    // rtbId :"",
    cnic: "",

    ntn: "",
    salesTaxCode: "",
    salesTaxAmount: 0,
    calculateTax: false,
    eInvoice: true,

    cheque_No: "",
    invoice_Date: "",
    invoice_Id: 0,
    grn_No: "",
    pO_No: "",
    barcode_No: "",
    demandType: "",
    invoice_Type: "",
    invoice_No: "",
    invoiceCategory: "",
    invoice_Desc: "",
    invoice_Amount: 0,
    final_Invoice_Amount: "",
    dept_coordinator: "",
    irUser: "",
    ipUser: "",
    taxTeam: "",
    vendor_Code: "",
    vendor_Name: "",
    lineManager: "",
    directorHR: "",
    sharedServices: "",
    invoice_attachment: "",
    additionalDocIds: [], // paths
    comments: "",
    firstClearText: "",
    secondClearText: "",
    due_Date: moment().format("YYYY-MM-DD"),
    provinceDuty : [],
    FCA_Details: [],
    Agreement_Details : [],
    stamp_Duty_Calculations : [],

    //   for import invoice (extra field)
    currency: "PKR",
    posting_Date: moment().format("YYYY-MM-DD"),
    document_Type: "KR",

    created_By: "",
    taxCard_List: [
      {
        category: "",
        purchaseType: "",
        supplierJurisdiction: "",
        supplierType: "",
        status: "",
        fillingStatus: "",
        goodsNature: "",
        taxType: "",
        taxCode: "",
        amount: "0",
      },
    ],
    // vendor Detail
    vendor_Details: [],
    // =======import invoice some tables are below ==========
    additionalDocIds_array: [], // additional documents in array

    invoice_Accounts_list: [
      // {
      //   glAccount: "",
      //   costCenter: "",
      //   costCenterOwner: "",
      //   costCenterOwnerName: "",
      //   horizonId: "",
      //   vendorCode: "",
      //   amount: 0,
      //   profitCenter: "",
      //   department: "",
      // },
    ],
    Expense_Accounts_list: [],

    // for Payment detail ("invoice_Payment" for po normal isInititor invoice).
    // ("invoice_Payment_Details" for import invoice) (will chnage).
    invoice_Payment: {
      ReferencePostingKey:'',
      advanceDocNo : "",
      advanceAmount:0,
      inv_Payment_Id: 0,
      invoice_Id: 0,
      postingKey: "",
      sglInd: "",
      tType: "",
      paymentTerms: "",
      paymentDays: "",
      paymentMethod: "",
      paymentMethSupp: "",
      individualPayee: false,
      account: "",
      amount: 0,
      taxAmount: 0,
      dueOn: moment().format("YYYY-MM-DD"),
      taxCode: "",
      description: "",
      order: "",
      costCenter: "",
      wbsElement: "",
      profitCenter: "",
      createdBy: "",
      createdDate: moment().format("YYYY-MM-DD"),
    },

    // Tax Table data (invoice_TaxDetails for po normal isInititor invoice)
    // ("invoice_Tax_Details" for import invoice) (will chnage).
    invoice_TaxDetails: [
      {
        taxId: 0,
        invoice_Id: 0,
        taxType: "",
        taxCode: "",
        amount: "",
        comments: "",
        created_By: "",
        created_On: new Date(),
        updated_By: "",
        updated_On: new Date(),
        taxCardId: 0,
      },
    ],

    // G/L Account detail. (actually for po_normal isInitiator)
    // (will change it to "invoice_Accounts_Details" for import invoice before hit api)
    invoice_Accounts: [
      // {
      //   rowId: Math.random(),
      //   accountId: 0,
      //   invoice_Id: invoiceId,
      //   glAccount: "",
      //   costCenter: "",
      //   accountType: "",
      //   amount: 0,
      //   costCenterOwner: "",
      //   stCode: "",
      //   order: "",
      //   profitCenter: "",
      //   wbsElement: "",
      //   created_By: "",
      //   created_On: new Date(),
      //   updated_By: "",
      //   updated_On: new Date(),
      //   fixedAsset: "",
      //   tType: "",
      //   description: "",
      //   expenseDate: "",
      //   horizonId: "",
      //   department: "",
      //   vendorCode: "",
      // },
    ],

    // PO Table Detail
    // "pO_Details" this keyword is used acctualy on backend, before hit the api it changes
    invoicePORef_List: [
      // we use this keyword due to reuse the PODetail table component.
      // {
      //   poItem: "", //  item #
      //   poNumber: "", // poNumber
      //   refDoc: "", // GRN No
      //   quantity: "", // GRN quantity
      //   val_Loccur: "", // GRN amount
      //   invoicE_QTY: "", //  consumed quantity
      //   invoicE_VAL: 0, // consumed Amount
      //   inpuT_QTY: "", //  invoice QTY
      //   inpuT_VAL: "", //  Invoice amount
      //   currency: "", // currency
      // },
    ],
    verified: false,
  });

  const [openWarningBox, setOpenWarningBox] = useState(false);
  const [openInvalidWarningDate, setOpenInvalidWarningDate] = useState(false);
  const [InvalidWarningDateState, setInvalidWarningDateState] = useState("");
  const [importPaymentDetail, setImportPaymentDetail] = useState({
    invoice_Payment_Details: [],
  });
  const [allowToProceed, setAllowToProceed] = useState(true);
  const [pageLoader, setPageLoader] = useState(false);
  useEffect(() => {
    if (invoicePayload.Invoice_id) {
      getMethodForPageRefresh(
        invoicePayload.Invoice_id,
        status,
        setAllowToProceed,
        setPageLoader
      );
    }
  }, [invoicePayload.Invoice_id, status]);
  const [newFormState, setNewFormState] = useState({
    isInitiator: false,
    isDeptCordinator: false,
    isHR: false,
    isPCDV: false, // EFDV initiator
    isVPPayment: false,
    isVFPayment: false,
    isSubmittedByVendor: false,
    isImport: false,
    isLogistics: false,
    submission_Date: moment().format("YYYY-MM-DD"),
    pO_Based: true,
    isPSID: false,
    psid: "",
    urgent: false,
    skipTaxStep: false,
    isReturn: false,
    invoice_Id: 0,
    grn_No: "",
    pO_No: "",
    po_Date: "",
    plant_Code : "",
    barcode_No: "",
    demandType: "",
    invoice_Type: "",
    invoice_No: "",
    invoiceCategory: "",
    invoice_Desc: "",
    invoice_Amount: "",
    final_Invoice_Amount: "",
    dept_coordinator: "",
    irUser: "",
    ipUser: "",
    taxTeam: "",
    vendor_Code: "",
    vendor_Name: "",
    invoice_Date: moment().format("YYYY-MM-DD"),
    lineManager: "",
    directorHR: "",
    sharedServices: "",
    invoice_attachment: "",
    additionalDocIds: "", // paths
    comments: "",
    aditional_Comments: "",
    firstClearText: "",
    secondClearText: "",
    // adjustAdvance : false,
    //   for import invoice (extra field)
    currency: "",
    posting_Date: moment().format("YYYY-MM-DD"),
    document_Type: "",
    created_By: "",

    // vendor Detail
    vendor_Details: [],
    // =======import invoice some tables are below ==========

    additionalDocIds_array: [], // additional documents in array

    due_Date: "",

    cnic: "",
    ntn: "",
    salesTaxCode: "",
    salesTaxAmount: 0,
    calculateTax: false,
    eInvoice: true,
    delv_Note_No: "",
    currency: "",
    daysto_sale_taxlapse: "",
    // for Payment detail
    invoice_Payment: {
      ReferencePostingKey:'',
      advanceDocNo :"",
      advanceAmount : 0 ,
      inv_Payment_Id: 0,
      invoice_Id: 0,
      postingKey: "",
      sglInd: "",
      tType: "",
      paymentTerms: "",
      paymentDays: "",
      paymentMethod: "",
      paymentMethSupp: "",
      individualPayee: false,
      account: "",
      amount: 0,
      taxAmount: 0,
      dueOn: moment().format("YYYY-MM-DD"),
      taxCode: "",
      description: "",
      order: "",
      costCenter: "",
      wbsElement: "",
      profitCenter: "",
      createdBy: "",
      createdDate: moment().format("YYYY-MM-DD"),
    },

    // Tax Table
    taxCard_List: [
      {
        category: "",
        purchaseType: "",
        supplierJurisdiction: "",
        supplierType: "",
        status: "",
        fillingStatus: "",
        goodsNature: "",
        taxType: "",
        taxCode: "",
        amount: "0",
      },
    ],
    invoice_TaxDetails: [
      {
        taxId: 0,
        invoice_Id: 0,
        taxType: "",
        taxCode: "",
        amount: "",
        comments: "",
        created_By: "",
        created_On: new Date(),
        updated_By: "",
        updated_On: new Date(),
        taxCardId: 0,
      },
    ],
    // G/L Account detail.
    invoice_Accounts: [
      // {
      //   accountId: 0,
      //   invoice_Id: invoiceId,
      //   glAccount: "",
      //   costCenter: "",
      //   accountType: "", // D/C (debit/ credit)
      //   amount: 0,
      //   costCenterOwner: "",
      //   stCode: "",
      //   order: "",
      //   profitCenter: "",
      //   wbsElement: "",
      //   created_By: "",
      //   created_On: new Date(),
      //   updated_By: "",
      //   updated_On: new Date(),
      //   fixedAsset: "",
      //   tType: "",
      //   description: "",
      //   expenseDate: "",
      //   horizonId: "",
      //   department: "",
      //   vendorCode: "",
      // },
    ],
    // PO Table Detail
    // "pO_Details" this keyword is used acctualy on backend, before hit the api it changes
    invoicePORef_List: [
      // we use this keyword due to reuse the PODetail table component.
      // {
      //   poItem: "", //  item #
      //   poNumber: "", // poNumber
      //   refDoc: "", // GRN No
      //   quantity: "", // GRN quantity
      //   val_Loccur: "", // GRN amount
      //   invoicE_QTY: "", //  consumed quantity
      //   invoicE_VAL: 0, // consumed Amount
      //   inpuT_QTY: "", //  invoice QTY
      //   inpuT_VAL: "", //  Invoice amount
      //   currency: "", // currency
      // },
    ],

    verified: false,
  });
  const [debitBalance, setDebitBalance] = useState(0);
  const [creditBalance, setCreditBalance] = useState(0);

  const [invoiceTaxDetail, setInvoiceTaxDetail] = useState({
    invoice_TaxDetails: [],
  });
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [totalGrnAmount, setTotalGrnAmount] = useState(0);
  const [balance, setBalance] = useState(0);

  const [attachmentURL, setAttachmentURL] = useState("");
  const [attachmentURLList, setAttachmentURLList] = useState([]);
  const [gLAccountTotal, setGLAccountTotal] = useState(0);
  const [vendorList, setVendorList] = useState([]);
  const [taxErrorMsg, setTaxErrorMsg] = useState("");
  const [Post, setPost] = useState(true);
  const [disablePostToSap , setDisablePostToSap] = useState(true)
  useEffect(() => {
    if (newFormState?.invoicePORef_List?.length > 0) {
      let counts = 0;
      for (let i = 0; i < newFormState?.invoicePORef_List?.length; i++) {
        const item = newFormState?.invoicePORef_List[i];
        // counts = counts + parseFloat(item.inpuT_VAL);

        const inputValue = parseFloat(item.inpuT_VAL);
        if (!isNaN(inputValue)) {
          counts += inputValue;
        }
      }
      setTotalGrnAmount(counts);
    }
  }, [newFormState.invoicePORef_List, POImportReference_Table]);

  // to set po based true or false.
  useEffect(() => {
    if (formState.invoice_Id) {
      if (formState?.pO_Based) {
        setPoBasedState("PO");
      } else {
        setPoBasedState("Non-PO");
      }
    }
  }, [formState.invoice_Id]);
  useEffect(() => {
    if (newFormState?.pO_Based) {
      if (
        newFormState?.invoicePORef_List &&
        newFormState?.invoicePORef_List.length > 0
      ) {
        // Run your logic if invoicePORef_List has a value and its length is greater than 0
        const totalAmount = newFormState?.invoicePORef_List?.reduce(
          (acc, item) => acc + parseFloat(item.inpuT_VAL || 0),
          0
        );
        let totalAmountString = totalAmount?.toString();
        setPO_InvoiceAmountforTax(totalAmountString);
      }
    }
  }, [newFormState.invoicePORef_List]);

  useEffect(() => {
    if (newFormState.invoice_Id && newFormState?.pO_Based) {
      const tax_invAmt =
        parseFloat(newFormState?.salesTaxAmount) +
        parseFloat(newFormState?.invoice_Amount);
      const bal =
        Number(totalGrnAmount || 0) +
        Number(newFormState?.salesTaxAmount || 0) +
        (gLAccountTotal || 0) -
        Number(newFormState?.invoice_Amount || 0);
      // const c = Number(bal.toFixed(3));
      // const c = Number(bal);

      const c = Number(bal);
      setBalance(c);
    }
  }, [
    newFormState?.salesTaxAmount,
    newFormState?.invoice_Amount,
    totalGrnAmount,
    gLAccountTotal,
  ]);

  useEffect(() => {
    // let debitt = Number(newFormState.salesTaxAmount);
    let debitt = 0;
    let creditt = 0;
    let _31PostingKeyTotal = 0;
    if (
      importPaymentDetail?.invoice_Payment_Details.length > 0 &&
      !newFormState?.pO_Based
    ) {
      for (
        let i = 0;
        i < importPaymentDetail?.invoice_Payment_Details?.length;
        i++
      ) {
        const ele = importPaymentDetail?.invoice_Payment_Details[i];
        //  this new from i2p 1.0....
        // var _p = refrenceList?.postingKey?.filter(
        //   (j) => j.ReferenceCode == ele.postingKey.split("-")[0].trim()
        // );
        // if (_p?.length > 0 && _p[0]?.ReferenceProp2 == "C")
        //   creditt += convertToFloat(ele.amount);
        // else debitt += convertToFloat(ele.amount);
        // end  this new from i2p 1.0....

        if (
          ele?.postingKey === "40" ||
          ele?.postingKey === "01" ||
          ele?.postingKey === "21" ||
          ele?.postingKey === "29" ||
          ele?.postingKey === "70"
        ) {
          // debit
          debitt = debitt + Number(ele?.amount || 0);
        }
        if (
          ele?.postingKey === "39" ||
          ele?.postingKey === "75" ||
          ele?.postingKey === "50" ||
          ele?.postingKey === "31"
        ) {
          // credit
          if (ele?.postingKey === "31") {
            _31PostingKeyTotal = _31PostingKeyTotal + Number(ele?.amount || 0);
            debitt = debitt + Number(ele?.taxAmount || 0);
          }
          creditt = creditt + Number(ele?.amount || 0);
        }
      }
      // setErrorMessage(
      // 40, 70, 75,
      //   _31PostingKeyTotal !== Number(newFormState?.invoice_Amount)
      //     ? "Invoice amount not mached with 31 posting-key"
      //     : ""
      // );
      setDebitBalance(debitt.toFixed(2));
      setCreditBalance(creditt.toFixed(2));
    } else if (
      importPaymentDetail?.invoice_Payment_Details.length === 0 &&
      !newFormState?.pO_Based
    ) {
      // setErrorMessage("Invoice amount not mached with 31 posting-key");
      setDebitBalance(Number(newFormState.salesTaxAmount));
      setCreditBalance(newFormState?.invoice_Amount);
    }
  }, [importPaymentDetail?.invoice_Payment_Details]);

  useEffect(() => {
    if (
      newFormState.invoice_Id &&
      newFormState.invoice_Amount !== "" &&
      !newFormState?.pO_Based
    ) {
      // setCreditBalance(newFormState.invoice_Amount);
      const filterdByPostingKey = importPaymentDetail?.invoice_Payment_Details
        .filter((x) => x.postingKey === "31")
        .reduce(
          (accumulator, currentValue) =>
            accumulator + Number(currentValue.amount) || 0,
          0
        );
      // setErrorMessage(
      //   filterdByPostingKey !== Number(newFormState?.invoice_Amount)
      //     ? "Invoice amount not mached with 31 posting-key"
      //     : ""
      // );
      // const totalAmount = filterdByPostingKey.reduce((accumulator, currentValue) => accumulator + currentValue.amount, 0);
    }
  }, [newFormState.invoice_Amount]);

  useEffect(() => {
    if (!newFormState?.pO_Based) {
      setBalance(creditBalance - debitBalance);
    }
  }, [creditBalance, debitBalance]);

  const changeHandler = (e) => {
    const { name, value } = e.target;
    setNewFormState((newFormState) => ({
      ...newFormState,
      [name]: value,
    }));
    if (name === "invoice_Type") {
      if (value === "DES") {
        setFormState((formState) => ({
          ...formState,
          skipTaxStep: true,
        }));
      } else {
        setFormState((formState) => ({
          ...formState,
          skipTaxStep: false,
        }));
      }
    }
    // if (name === "pO_No") {
    //   getVendorByPO(value, "vendor_Code", setNewFormState);

    // }
  };

  const showVendorAndPO_NumberForImport = () => {
    let show = selectedRole?.roleName === "Import" ? true : false;
    if (
      selectedRole?.roleName === "Import" &&
      formState.demandType === "Deposit"
    ) {
      show = false;
    }

    return show;
  };

  const showVendorCodeForImport = () => {
    let show = selectedRole?.roleName === "Import" ? true : false;
    if (
      selectedRole?.roleName === "Import" &&
      formState.demandType === "Spare Parts"
    ) {
      show = false;
    }
    if (
      selectedRole?.roleName === "Import" &&
      formState.demandType === "Material"
    ) {
      show = false;
    }
    if (
      selectedRole?.roleName === "Import" &&
      formState.demandType === "Samples"
    ) {
      show = false;
    }
    return show;
  };

  // to upload the file and get path.
  const poBasedHandler = (e) => {
    setPoBasedState(e.target.value);
    clearState(setFormState);
  };

  const roleHandler = (newValue) => {
    setFormState((formState) => ({
      ...formState,
      isInitiator: newValue.roleName === "I2P Initiator" ? true : false,
      isHR: newValue.roleName === "HR" ? true : false,
      isPCDV: newValue.roleName === "EFDV Initiator" ? true : false,
      isImport: newValue.roleName === "Import" ? true : false,
      isLogistics: newValue.roleName === "Logistic" ? true : false,
    }));

    setSelectedRole(newValue);
  };
  const [specialCharError, setSpecialCharError] = useState(false);

  const validateSpecialCharacters = (text) => {
    return /[!@#$%^&*()_+={}\[\]:;"'<>,?/~\\-`]/.test(text);
  };

  const submitHandler = () => {
    // if (formState?.isImport) {
    //   updateIPInvoiceByImport(
    //     newFormState,
    //     invoiceTaxDetail,
    //     importPaymentDetail,
    //     setNewFormState,
    //     poBasedState,
    //     setErrorMessage,
    //     setSuccessMessage,
    //     setAttachInvoiceLoading,
    //     navigate
    //   );
    //   setOpenWarningBox(false);
    // } else
    if (newFormState?.isReturn) {
      changeInvoiceStatus(
        // formState.rtbId,
        formState.invoice_Id,
        statusForPayload,
        setConfirmationModal,
        setAttachInvoiceLoading,
        setSuccessMessage,
        setErrorMessage,
        navigate,
        newFormState.comments,
        newFormState.aditional_Comments,
        setPost
      );
      setConfirmationModal(false);
    } else if (
      status === "SendToIPFromSupervisor" ||
      status === "SendToReviewerFromSupervisor"
    ) {
      ChangeInvoiceStatus_V1(
        formState.invoice_Id,
        statusForPayload,
        setConfirmationModal,
        setAttachInvoiceLoading,
        setSuccessMessage,
        setErrorMessage,
        navigate,
        newFormState.comments,
        setPost
      );
      setConfirmationModal(false);
    } else {
   // Create a deep copy (or shallow copy depending on structure)

           const { Agreement_Details, FCA_Details, provinceDuty, stamp_Duty_Calculations, ...filteredFormState } = newFormState;
  let finalFormState = newFormState;

if (status === "SendToIP") {
  finalFormState = {
    ...newFormState,
    invoicePORef_List: filteredFormState.invoicePORef_List.map(item => {
      const { selected, ...rest } = item; // remove 'selected'
      return rest;
    }),
  };
}

// Then call updateIPInvoice with the cleaned data
updateIPInvoice(
  finalFormState,
  setNewFormState,
  poBasedState,
  setErrorMessage,
  setSuccessMessage,
  setAttachInvoiceLoading,
  navigate,
  importPaymentDetail,
  setPost,
  multipleData
);

setOpenWarningBox(false);

      setOpenWarningBox(false);
    }
    setOpenWarningBox(false);
  };
  const [dataLoading, setDataLoading] = useState(false);
  const [refrenceList, setRefrenceList] = useState({
    invoice_Type: [],
    document_Type: [],
    paymentTerms: [],
    postingKey: [],
    sglInd: [],
    tType: [],
    paymentMethod: [],
    paymentMethSupp: [],
    currency: [],
  });
  useEffect(() => {
    getRefrenceDataList(
      "invoiceType",
      "invoice_Type",
      () => {},
      setMultipleData
    );
    getRefrenceDataList(
      "DocumentType",
      "document_Type",
      () => {},
      setMultipleData
    );
    getRefrenceDataList(
      "PaymentTerm",
      "paymentTerms",
      setFormState,
      setMultipleData
    );
    getRefrenceDataList(
      "postingKey",
      "postingKey",
      setFormState,
      setMultipleData
    );
    getRefrenceDataList("sglInd", "sglInd", setFormState, setMultipleData);
    getRefrenceDataList("tType", "tType", setFormState, setMultipleData);

    getRefrenceDataList(
      "PaymentMethod",
      "paymentMethod",
      setFormState,
      setMultipleData
    );
    getRefrenceDataList(
      "PaymentMethodSupp",
      "paymentMethSupp",
      setFormState,
      setMultipleData
    );
    getRefrenceDataList("Currency", "currency", setFormState, setMultipleData);
    getAllRefrenceDataList(refrenceList);
    getUserRoles(setRoles, setRolesLoading);

    if (invoicePayload && role) {
      // getVendorDetail(invoicePayload.Vendor_Code, setVendorList, () => {});
      vendorTaxDetailForCnic(setFormState, invoicePayload?.Vendor_Code);
      getInvoiceByInvoiceIdAndRoleId(invoicePayload, role, setFormState);
      // getInvoiceByInvoiceIdAndRoleId(
      //   setIsLoading,
      //   invoicePayload,
      //   role,
      //   setFormState
      // );

      // if (!formState.isImport) {
      getAllInvoiceDetailByInvoiceIdV2(
        setFormState,
        setMultipleData,
        invoicePayload?.Invoice_id,
        () => {},
        setImportPaymentDetail,
        "",
        setDataLoading
      );

      // }
    }
  }, []);

  useEffect(() => {
    if (invoicePayload && role) {
      if (formState?.invoice_Type === "ERF") {
        getCommentsByERFInvoiceNo(
          setCommentsList,
          setCommentsLoading,
          formState?.invoice_No
        );
      } 
        else if (formState?.invoice_Type === "ARF") {
        getCommentsByARFInvoiceNo(
          setCommentsList,
          setCommentsLoading,
          formState?.invoice_No
        );
      }
      else {
        getCommentsByInvoiceId(
          setCommentsList,
          setCommentsLoading,
          invoicePayload?.Invoice_id
        );
      }
    }
  }, [formState.invoice_Type]);
  const [po_Loading, setPo_Loading] = useState(false);
  useEffect(() => {
    if (
      formState?.isImport &&
      formState?.pO_No &&
      formState?.invoicePORef_List?.length === 0
    ) {
      getImportPoData(
        formState?.pO_No,
        invoicePayload?.Invoice_id,
        setFormState,
        setPo_Loading
      );
    }
  }, [formState?.isImport, formState?.pO_No]);

  useEffect(() => {
    let filterd_data = [];
    if (formState?.additionalDocIds?.length > 0) {
      filterd_data = formState.additionalDocIds.filter((e) => Number(e) !== 0);
    }
    setAttachmentURLList((pre) => [
      formState?.invoice_attachment,
      ...filterd_data,
    ]);
    if (formState?.invoice_attachment) {
      setAttachmentURL(formState?.invoice_attachment);
    } else {
      setAttachmentURL(formState?.additionalDocIds[0]);
    }
  }, [formState?.invoice_attachment, formState?.additionalDocIds]);

  useEffect(() => {
    if (newFormState?.additionalDocIds?.length > 0) {
      setAttachmentURLList((pre) => [
        ...pre,
        newFormState?.additionalDocIds[
          newFormState?.additionalDocIds.length - 1
        ],
      ]);
    }
  }, [newFormState?.additionalDocIds]);

  useEffect(() => {
    if (formState?.invoice_No !== "") {
      setNewFormState(formState);
      setNewFormState((newFormState) => ({
        ...newFormState,
        additionalDocIds: [],
        invoice_attachment: "",
      }));
    }
  }, [formState]);
  useEffect(() => {
    if (
      formState?.invoice_No &&
      formState?.skipTaxStep &&
      status === "SendToIP"
    ) {
      vendorTaxDetailV2(
        setFormState,
        invoicePayload?.Vendor_Code,
        formState.invoice_Amount
      );
    }
  }, [formState?.invoice_No]);

  //  used for show taxdetail when invoice is created by import.
  useEffect(() => {
    if (formState?.taxCard_List?.length > 0 && formState.isImport) {
      let tempArray = [];
      for (let i = 0; i < formState?.taxCard_List?.length; i++) {
        const item = formState?.taxCard_List[i];
        const obj = {
          taxId: 0,
          invoice_Id: invoicePayload?.Invoice_id,
          taxType: item?.taxType,
          taxCode: item?.taxCode,
          amount: formState.invoice_Amount,
          comments: "",
          created_By: "",
          created_On: new Date(),
          updated_By: "",
          updated_On: new Date(),
          taxCardId: 0,
        };
        tempArray.push(obj);
      }
      setInvoiceTaxDetail((formState) => ({
        ...formState,
        invoice_TaxDetails: tempArray,
      }));
    }
  }, [formState?.taxCard_List]);
  useState(false);
  useEffect(() => {
    let total = 0;
    let amount = 0;
    let tempArr = importPaymentDetail?.invoice_Payment_Details;
    if (formState.invoice_Accounts.length > 0) {
      for (let index = 0; index < formState.invoice_Accounts.length; index++) {
        const item = formState.invoice_Accounts[index];
        if (item.accountType === "Debit") {
          if (
            index === 0 &&
            formState?.salesTaxAmount === "0.01" &&
            !formState?.pO_Based
          ) {
            amount =
              parseFloat(item.amount ? item?.amount || 0 : item?.Amount || 0) -
              formState?.salesTaxAmount;
            item.amount = amount;
          } else if (
            index === 0 &&
            newFormState?.salesTaxAmount === "0.01" &&
            !formState?.pO_Based
          ) {
            amount =
              parseFloat(item.amount ? item?.amount || 0 : item?.Amount || 0) -
              newFormState?.salesTaxAmount;
            item.amount = amount;
          }
          total =
            total +
            parseFloat(item.amount ? item?.amount || 0 : item?.Amount || 0);
        } else if (item.accountType === "Credit") {
          total = total - parseFloat(item.amount ? item?.amount : item?.Amount);
        }
        // total = parseFloat(item.amount ? item?.amount : item?.Amount) + total;
      }
      importPaymentDetail?.invoice_Payment_Details?.map((item, index) => {
        if (
          index === 1 &&
          newFormState?.salesTaxAmount === "0.01" &&
          !formState?.pO_Based &&
          (item.postingKey === "40" || item.postingKey === "01")
        ) {
          amount =
            parseFloat(
              tempArr[index].amount
                ? tempArr[index]?.amount || 0
                : tempArr[index]?.Amount || 0
            ) - newFormState?.salesTaxAmount;
          tempArr[index].amount = amount;
        }

        setImportPaymentDetail((importPaymentDetail) => ({
          ...importPaymentDetail,
          invoice_Payment_Details: tempArr,
        }));
        // tempArr[index].accountType = item.accountType ? item.accountType : item.AccountType ? item.AccountType : "Debit"
      });

      setGLAccountTotal(total);
    }
    // else if (formState?.invoice_No) {
    //   setFormState((formState) => ({
    //     ...formState,
    //     invoice_Accounts: [
    //       {
    //         rowId: Math.random(),
    //         accountId: 0,
    //         invoice_Id: invoiceId,
    //         glAccount: "",
    //         costCenter: "",
    //         accountType: "",
    //         amount: 0,
    //         costCenterOwner: "",
    //         stCode: formState?.salesTaxCode?.split(" - ")[0] || "",
    //         order: "",
    //         profitCenter: "",
    //         wbsElement: "",
    //         created_By: "",
    //         created_On: new Date(),
    //         updated_By: "",
    //         updated_On: new Date(),
    //         fixedAsset: "",
    //         tType: "",
    //         description: formState.invoice_Desc,
    //         expenseDate: "",
    //         horizonId: "",
    //         department: "",
    //         vendorCode: "",
    //       },
    //     ],
    //   }));
    // }
  }, [
    formState?.invoice_Accounts,
    formState?.invoicePORef_List,
    formState?.invoice_No,
    newFormState?.salesTaxAmount,
  ]);

  const [vendor__Code, setVendor__Code] = useState("");
  const [vendor__Name, setVendor__Name] = useState("");

  useEffect(() => {
    if (formState?.vendor_Code) {
      setVendor__Code(formState?.vendor_Code);
    } else {
      setFormState((formState) => ({
        ...formState,
        vendor_Code: vendor__Code,
      }));
    }
    if (formState?.vendor_Name) {
      setVendor__Name(formState?.vendor_Name);
    } else {
      setFormState((formState) => ({
        ...formState,
        vendor_Name: vendor__Name,
      }));
    }
  }, [formState.vendor_Code]);

  // invoice_attachment: "",
  // additionalDocIds: "", // paths

  // useEffect(() => {
  //   if (!changed && formState?.additionalDocIds.length > 0) {
  //     setNewFormState((newFormState) => ({
  //       ...newFormState,
  //       additionalDocIds: [],
  //     }));
  //     setChanged(true);
  //   }

  // }, [formState.additionalDocIds]);

  const showAttachmentsHandler = (attachment_URL) => {
    setAttachmentURL(attachment_URL);
  };

  // const confirmHandler = (e) => {
  //   e.preventDefault();
  //   let isError = false;
  //   let amount = ""
  //      let errorRows = [];
  //   for (
  //     let index = 0;
  //     index < newFormState?.invoice_Accounts?.length;
  //     index++
  //   ) {
  //     const item = newFormState?.invoice_Accounts?.[index];
  //     if(!item?.glAccount && (!item?.amount || item?.amount === 0 )&& !item?.accountType){
  //       isError = false;

  //     }else if (!item?.glAccount && ((item?.amount || item?.amount === 0 ) || item?.accountType)){
  //       isError = true;
  //       errorRows.push(index + 1);
  //     }
  //    else if (item?.glAccount && (item?.amount || !item?.amount === 0) || item?.accountType) {
  //       if (
  //         // !item?.stCode ||
  //         (!(item?.costCenter || item?.profitCenter))
  //         // !item?.description
  //       ) {
  //         isError = true;
  //         errorRows.push(index + 1);
  //       }
  //     }else if(item?.amount === 0){
  //       isError = true;
  //       amount="Amount should not be zero"
  //       errorRows.push(index + 1);
  //     }
  //   }
  //   const containsSpecialChars = validateSpecialCharacters(
  //     newFormState?.invoice_Desc
  //   );
  //   const expenseListContainsSpecialChars =
  //     newFormState?.invoice_Accounts?.some((item) =>
  //       validateSpecialCharacters(item.description)
  //     );

  //   if (newFormState?.isReturn) {
  //     setConfirmationModal(true);
  //   } else {
  //     if (!isError) {
  //       if (containsSpecialChars || expenseListContainsSpecialChars) {
  //         setSpecialCharError(true);
  //       } else {
  //         const invoiceAmount = parseFloat(formState?.invoice_Amount) || 0;
  //         const baseAmount = parseFloat(totalBaseAmount) || 0;
  //         if((formState?.skipTaxStep && status !== "SendToIPFromSupervisor") && invoiceAmount !== baseAmount){

  //           setErrorMessageForAmount("Income Tax WH base amount must be equal to Invoice Amount.")
  //            // Scroll to the error message section
  //         if (errorMessageRef.current) {
  //           errorMessageRef.current.scrollIntoView({
  //             behavior: 'smooth',
  //             block: 'start',
  //           });
  //       }
  //     }else{
  //         setErrorMessageForAmount("")
  //         setErrorMessage("")
  //         amount ="";
  //         setSpecialCharError(false);
  //         setOpenWarningBox(true);
  //       }

  //         // Continue with form submission logic here
  //       }
  //     } else {
  //       const errorRowsString = errorRows.join(', ');
  //       if(amount){
  //         setErrorMessage(`Please Fill GL Amount Entry should not be zero at row ${errorRowsString}.`);
  //       }else{
  //         setErrorMessage(`Please Fill GL Account  at row ${errorRowsString}.`);
  //       }

  //       // setErrorMessage("Please Fill GL Account Entry");
  //     }
  //   }
  // };

  const confirmHandler = (e) => {
    e.preventDefault();
    const totalZ1Z3 =
      calculateTotalGLAmount("Z1") + calculateTotalGLAmount("Z3");
    const totalZ2Z4 =
      calculateTotalGLAmount("Z2") + calculateTotalGLAmount("Z4");
    let isError = false;
    let errorRows = [];
    if (
      newFormState?.invoice_Accounts &&
      newFormState.invoice_Accounts.length > 0 &&
      formState.invoice_Type !== 'Final Settlement - Distributor'
    ) {
      for (
        let index = 0;
        index < newFormState?.invoice_Accounts?.length;
        index++
      ) {
        const item = newFormState?.invoice_Accounts?.[index];

        // Check for required fields only if the user has started entering data
        if (
          item &&
          (item.glAccount ||
            item.amount ||
            item.accountType ||
            item.costCenter ||
            item.profitCenter)
        ) {
         const hasPostingKey29 =
  status === "SendToIPFromSupervisor" &&
  importPaymentDetail?.invoice_Payment_Details?.some(
    (entry) => entry.postingKey === "29"
  );

const hasRequiredFields =
  hasPostingKey29 ||
  (item?.glAccount &&
    item?.amount !== undefined &&
    item?.amount !== 0 &&
    item?.accountType &&
    (item?.costCenter || item?.profitCenter));

          if (!hasRequiredFields) {
            isError = true;
            let missingFields = [];
            if (!item?.glAccount) missingFields.push("GL Account");
            if (
              item?.amount === undefined ||
              item?.amount === 0 ||
              !item?.amount
            )
              missingFields.push("Amount");
            if (!item?.accountType) missingFields.push("Account Type");
            if (!item?.costCenter && !item?.profitCenter)
              missingFields.push("Cost Center or Profit Center");
            if (item?.costCenter?.split("-")[0] && !item?.costCenterOwnerName)
              missingFields.push("costCenterOwnerName");
            errorRows.push({ index: index + 1, missingFields });
          }
        }
      }
    }
    const containsSpecialChars = validateSpecialCharacters(
      newFormState?.invoice_Desc
    );
    const expenseListContainsSpecialChars =
      newFormState?.invoice_Accounts?.some((item) =>
        validateSpecialCharacters(item.description)
      );

    if (newFormState?.isReturn) {
      if(newFormState.skipTaxStep && statusForPayload=="SendToTaxTeamFromIP" && !reviewerModal){
        setOpenTaxModal(true);
      }else if(reviewer=='OK'){
        setReviewerModal(true)
      } else {
        setConfirmationModal(true);
      }
    } else {
      if (!isError) {
        if (containsSpecialChars || expenseListContainsSpecialChars) {
          setSpecialCharError(true);
        } else {
          const invoiceAmount = parseFloat(formState?.invoice_Amount) || 0;
          const IncomebaseAmount = parseFloat(totalZ1Z3) || 0;
          const SalebaseAmount = parseFloat(totalZ2Z4) || 0;
          if (
            formState?.skipTaxStep &&
            status !== "SendToIPFromSupervisor" &&
            status !== "SendToReviewerFromSupervisor" &&
            taxErrorMsg
          ) {
            if (errorMessageRef.current) {
              errorMessageRef.current.scrollIntoView({
                behavior: "smooth",
                block: "start",
              });
            }
          } else if (
            formState?.skipTaxStep &&
            status !== "SendToIPFromSupervisor" &&
            status !== "SendToReviewerFromSupervisor" &&
            invoiceAmount !== IncomebaseAmount &&
            IncomebaseAmount !== 0
          ) {
            setErrorMessageForAmount(
              "Income Tax WH base amount must be equal to Invoice Amount."
            );
            // Scroll to the error message section
            if (errorMessageRef.current) {
              errorMessageRef.current.scrollIntoView({
                behavior: "smooth",
                block: "start",
              });
            }
          } else if (
            formState?.skipTaxStep &&
            status !== "SendToIPFromSupervisor" &&
            status !== "SendToReviewerFromSupervisor" &&
            SalebaseAmount > invoiceAmount &&
            SalebaseAmount !== 0
          ) {
            setErrorMessageForAmount(
              "Sale Tax WH base amount should not exceed the to Invoice Amount."
            );
            // Scroll to the error message section
            if (errorMessageRef.current) {
              errorMessageRef.current.scrollIntoView({
                behavior: "smooth",
                block: "start",
              });
            }
          } else {
            setErrorMessageForAmount("");
            setErrorMessage("");

            setSpecialCharError(false);
            (!openTaxModal && !reviewerModal) && setOpenWarningBox(true);
          }

          // Continue with form submission logic here
        }
      } else {
        let errorMessage = `Please fill GL Entry required fields and ensure Amount is not zero:\n`;
        errorRows.forEach(({ index, missingFields }) => {
          errorMessage += `Row ${index}: ${missingFields.join(", ")}\n`;
        });

        setErrorMessage(errorMessage);

        // setErrorMessage("Please Fill GL Account Entry");
      }
    }
  };
  const calculateTotalGLAmount = (taxType) => {
    const filteredList = newFormState?.taxCard_List?.filter(
      (data) => data.taxType === taxType
    );
    const totalAmount = filteredList?.reduce(
      (prev, curr) => prev + Number(curr.amount),
      0
    );
    return totalAmount;
  };
  // const totalZ1Z3 = calculateTotalGLAmount("Z1") + calculateTotalGLAmount("Z3");
  // const totalZ2Z4 = calculateTotalGLAmount("Z2") + calculateTotalGLAmount("Z4");
  const gltotal = 0;
  const [paymentTerm, setPaymentTerm] = useState("");
  useEffect(() => {
    if (formState?.pO_No && formState?.pO_Based) {
      getVendorForPaymentMethod(formState?.pO_No, setFormState);
      getVendorDetail(invoicePayload.Vendor_Code, setVendorList, () => {});
    } else if (formState?.invoice_No) {
      getVendorDetail(invoicePayload.Vendor_Code, setVendorList, () => {});
    }
  }, [formState?.pO_No, formState?.vendor_Code]);

  useEffect(() => {
    if (
      multipleData?.paymentTerms?.length > 0 &&
      formState.invoice_Payment?.paymentTerms
    ) {
      let days = multipleData?.paymentTerms?.filter(
        (item) => item.ReferenceCode === formState.invoice_Payment?.paymentTerms
      );
      let date = moment(formState?.invoice_Date).format("YYYY-MM-DD");
      if (formState?.invoice_No) {
        let paymentMethod = "";
        let paymentMethodSupp = "";

        if (user.Location === "1") {
          // thsi is for MPAS
          if (!vendorList[0]?.Bank_Key || vendorList[0]?.Bank_Key === "") {
            paymentMethod = "1";
            paymentMethodSupp = "C";
          } else if (vendorList[0]?.Bank_Key?.includes("SCB")) {
            paymentMethod = "W";
            paymentMethodSupp = "C";
          } else {
            paymentMethod = "V";
            paymentMethodSupp = "C";
          }
        } else {
          if (!vendorList[0]?.Bank_Key || vendorList[0]?.Bank_Key === "") {
            paymentMethod = "1";
            paymentMethodSupp = "C";
          } else if (vendorList[0].Bank_Key?.includes("SCB")) {
            paymentMethod = "6";
            paymentMethodSupp = "C";
          } else {
            paymentMethod = "7";
            paymentMethodSupp = "C";
          }
        }
        if (formState.isImport && formState.isPSID) {
          paymentMethod = "6";
          paymentMethodSupp = "C";
        } else if (formState.isImport && !formState.isPSID) {
          paymentMethod = "3";
          paymentMethodSupp = "P";
        }

        setFormState((formState) => ({
          ...formState,
          invoice_Payment: {
            ...formState?.invoice_Payment,
            dueOn: moment(date, "YYYY-MM-DD")
              .add(Number(days[0]?.ReferenceProp1), "days")
              .format("YYYY-MM-DD"),
            paymentMethod: paymentMethod,
            paymentMethSupp: paymentMethodSupp,
          },
        }));

        // setNewFormState((formState) => ({
        //   ...formState,
        //   invoice_Payment: {
        //     ...formState?.invoice_Payment,
        //     paymentMethod: paymentMethod,
        //     paymentMethSupp: paymentMethodSupp,
        //   },
        // }));
        // setNewFormState((formState) => ({
        //   ...formState,
        //   invoice_Payment: {
        //     ...formState?.invoice_Payment,
        //     dueOn: moment(date, "YYYY-MM-DD")
        //       .add(Number(days[0]?.ReferenceProp1), "days")
        //       .format("YYYY-MM-DD"),
        //     paymentMethod:
        //       newFormState?.demandType === "Material" && newFormState?.isPSID
        //         ? "6"
        //         : "3",
        //     paymentMethSupp:
        //       newFormState?.demandType === "Material" && newFormState?.isPSID
        //         ? "C"
        //         : "P",
        //   },
        // }));
      }
    } else if (
      multipleData?.paymentTerms?.length > 0 &&
      vendorList.length === 1
    ) {
      setFormState((formState) => ({
        ...formState,
        invoice_Payment: {
          ...formState?.invoice_Payment,
          paymentTerms: paymentTerm ? paymentTerm : vendorList[0].Payment_Terms,
        },
      }));
    }
  }, [
    formState?.invoice_Payment?.paymentTerms,
    multipleData?.paymentTerms,
    paymentTerm,
    vendorList[0],
  ]);

  useEffect(() => {
    if (
      newFormState?.invoice_No &&
      !newFormState?.invoice_Payment?.paymentMethod
    ) {
      let paymentMethod = "";
      let paymentMethodSupp = "";

      if (user.Location === "1") {
        // thsi is for MPAS
        if (!vendorList[0]?.Bank_Key || vendorList[0]?.Bank_Key === "") {
          paymentMethod = "1";
          paymentMethodSupp = "C";
        } else if (vendorList[0]?.Bank_Key?.includes("SCB")) {
          paymentMethod = "W";
          paymentMethodSupp = "C";
        } else {
          paymentMethod = "V";
          paymentMethodSupp = "C";
        }
      } else {
        if (!vendorList[0]?.Bank_Key || vendorList[0]?.Bank_Key === "") {
          paymentMethod = "1";
          paymentMethodSupp = "C";
        } else if (vendorList[0].Bank_Key?.includes("SCB")) {
          paymentMethod = "6";
          paymentMethodSupp = "C";
        } else {
          paymentMethod = "7";
          paymentMethodSupp = "C";
        }
      }
      if (formState.isImport && formState.isPSID) {
        paymentMethod = "6";
        paymentMethodSupp = "C";
      } else if (formState.isImport && !formState.isPSID) {
        paymentMethod = "3";
        paymentMethodSupp = "P";
      }
      setNewFormState((formState) => ({
        ...formState,
        invoice_Payment: {
          ...formState?.invoice_Payment,
          paymentMethod: paymentMethod,
          paymentMethSupp: paymentMethodSupp,
        },
      }));
      // setNewFormState((formState) => ({
      //   ...formState,
      //   invoice_Payment: {
      //     ...formState?.invoice_Payment,
      //     paymentMethod:
      //       newFormState?.demandType === "Material" && newFormState?.isPSID
      //         ? "6"
      //         : "3",
      //     paymentMethSupp:
      //       newFormState?.demandType === "Material" && newFormState?.isPSID
      //         ? "C"
      //         : "P",
      //   },
      // }));
    }
  }, [newFormState?.invoice_Payment?.paymentMethod]);

  useEffect(() => {
    if (
      formState?.invoice_Accounts_list?.length > 0 &&
      formState?.Expense_Accounts_list?.length === 0
    ) {
      let temp = [];

      for (let i = 0; i < formState?.invoice_Accounts_list?.length; i++) {
        const item = formState?.invoice_Accounts_list[i];
        const obj = {
          accountId: 0,
          invoice_Id: Number(invoicePayload?.Invoice_id),
          // expenseDate: item?.ExpenseDate,
          expenseDate:
    typeof item?.ExpenseDate === "string" && item?.ExpenseDate?.trim() !== ""
      ? item.ExpenseDate
      : "",
          glAccount: item?.GLAccount?.split("-")[0]?.trim(),
          GLAccount: item?.GLAccount, // I use it for expense
          costCenter1: item?.CostCenter, // I use it for expense
          costCenter: item?.CostCenter?.split("-")[0]?.trim(),
          costCenterOwner: item?.CostCenterOwner || "",
          costCenterOwnerName: item?.CostCenterOwnerName || "",
          wbsElement: item?.WBSElement || "",
          // horizonId: item?.HorizonId || "",
          // vendor_Code: item?.VendorCode || "",
          horizonId: item?.HorizonId,
          vendor_Code: item?.VendorCode,
          // amount: Number(item?.Amount) || 0,
          amount: Number(item?.Amount)?.toFixed(2),
          profitCenter: Number(item?.ProfitCenter) || "",
          department: item?.Department,
          description: item?.Description || "",
          tType: item?.TType || "",
          fixedAsset: item?.FixedAsset || "",
          customerAccountNo: item?.CustomerAccountNo || item?.customerAccountNo  || "",
          fsDocNo: item?.FSDocNo || item?.fsDocNo || "",
          fsDocDate: item?.FSDocDate || item?.fsDocDate || "",
          vendorCode: item?.VendorCode || item?.vendorCode || "",
        };
        temp.push(obj);
      }

      setFormState((formState) => ({
        ...formState,
        Expense_Accounts_list: temp,
        invoice_Accounts_list: temp,
      }));
    }
  }, [formState]);

  const myStyle = {
    width: "50%",
    // width:"500px",
    height: "100px",
    backgroundColor: "#EBEDEF",
    borderRadius: "3px",
    display: "flex",
    justifyContent: "space-around",
    marginTop: "10px",
  };
  const zero = 0;

  const [dragfile, setDragFile] = useState(false);
  const [dragloader, setDragLoader] = useState(false);
  const handleDrag = function (e) {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragLoader(true);
    } else if (e.type === "dragleave") {
      setDragLoader(false);
      setDragFile(true);
    }
  };
  const [attachmentFile_UI, setAttchmentFile_UI] = useState([]);
  const [docError, setDocError] = useState("");
  const [attachError, setAttachError] = useState("");
  const [alertMessage, setAlertMessage] = useState(false);
  // triggers when file is dropped
  const handleDrop = function (e) {
    e.preventDefault();
    e.stopPropagation();
    setDragLoader(false);

    if (
      // newFormState?.invoice_attachment === "" &&
      e.dataTransfer.files &&
      e.dataTransfer.files[0]
    ) {
      uploadAdditioalDocumentFile(
        e,
        setNewFormState,
        setAttachInvoiceLoading,
        "additionalDocIds",
        additionalAttachmentRef,
        setDocError,
        setAttachError,
        setAlertMessage,
        invoicePayload,
        selectedRole,
        dragfile,
        setDragFile,
        setSuccessMessage
      );
      // uploadFile_v1(
      //   e,
      //   setNewFormState,
      //   setAttachInvoiceLoading,
      //   "invoice_attachment",
      //   setAttchmentFile_UI,
      //   invoice_attachmentRef,
      //   setAttachmentURLList,
      //   setAttachmentURL,
      //   attachmentURLList,
      //   newFormState.invoice_attachment,
      //   setDocError,
      //   setAttachError,
      //   setAlertMessage,
      //   invoicePayload,
      //   selectedRole,
      //   dragfile,
      //   setDragFile,
      //   setSuccessMessage
      // );
    }
  };
 
  return (
    <div>
      {/* {allowToProceed ? ( */}
        <Card
          onDragEnter={handleDrag}
          onDragLeave={handleDrag}
          onDragOver={handleDrag}
          onDrop={handleDrop}
        >
          <Backdrop
            sx={{
              color: "#fff",
              zIndex: (theme) => theme.zIndex.drawer + 1,
            }}
            open={dragloader || dataLoading}
          ></Backdrop>
          {(Post && allowToProceed) && (
            <>
              <CardHeader color="primary" text>
                <CardText
                  style={{
                    padding: "0px 27px",
                    backgroundColor: "#031C30",
                    color: "white",
                  }}
                >
                  <Grid container justifyContent="space-between">
                    <Grid item xs={2} sm={3} md={3} lg={6}>
                      <h1 style={{ fontSize: "24px" }}>Process Invoice</h1>
                    </Grid>
                    <Grid item xs={6} sm={6} md={6} lg={6}>
                      <IconButton
                        variant="contained"
                        style={{ float: "right", marginTop: "1.5%" }}
                        onClick={() => navigate("/home")}
                      >
                        <ArrowBack
                          style={{ color: "#fff" }}
                          titleAccess="Go Back"
                        />
                      </IconButton>
                    </Grid>
                  </Grid>
                </CardText>
              </CardHeader>
              <CardBody>
                <Backdrop
                  sx={{
                    color: "#fff",
                    zIndex: (theme) => theme.zIndex.drawer + 1,
                  }}
                  open={attachInvoiceLoading || dataLoading}
                  invisible={dataLoading}
                >
                  {/* <CircularProgress color="inherit" /> */}
                  <Spinner />
                </Backdrop>
                <Grid container spacing={1} style={{ marginTop: "1px" }}>
                  {/* Submitter role */}
                  <Grid item xs={12} sm={12} md={3} lg={3}>
                    <Typography style={{ color: "black" }}>
                      Submitter Role:{" "}
                      <span className={classes.asterisk}>*</span>
                    </Typography>
                    <Autocomplete
                      id="submitter_role"
                      options={roles}
                      size="small"
                      value={selectedRole}
                      getOptionLabel={(option) =>
                        (option !== "" && `${option?.roleName}`) || ""
                      }
                      loading={rolesLoading}
                      onChange={(event, newValue) => {
                        roleHandler(newValue);
                      }}
                      disabled
                      renderInput={(params) => (
                        <TextField {...params} type="text" name="" required />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={9} lg={9}></Grid>
                </Grid>

                {!formState.isImport &&
                  !formState?.isPCDV &&
                  !formState?.isHR && (
                    <InvoiceCheckboxes
                      formState={formState}
                      setFormState={setFormState}
                      selectedRole="IP"
                      disabled={true}
                    />
                  )}
                <Grid container>
                  <Grid item xs={12} sm={12} md={12} lg={6}>
                    {!formState.isImport &&
                      !formState?.isPCDV &&
                      !formState?.isHR && (
                        <InvoiceRadioButtons
                          formState={formState}
                          setFormState={setFormState}
                          selectedRole="IP"
                          physicalOrEInvoice={physicalOrEInvoice}
                          poBasedState={poBasedState}
                          alignForAttachment={true}
                        />
                      )}
                    {formState?.invoice_No && (
                      <InvoiceTextField
                      formState= {{
                        ...formState, 
                        po_Date : formState?.po_Date , 
                        plant_Code : formState?.plant_Code
                      }}
                        newFormState={formState}
                        setNewFormState={setFormState}
                        selectedRole="IP"
                        disabled={true}
                        poBasedState={poBasedState}
                        showVendorAndPO_NumberForImport={
                          showVendorAndPO_NumberForImport
                        }
                        showVendorCodeForImport={showVendorCodeForImport}
                        invoice_attachmentRef={invoice_attachmentRef}
                        additionalAttachmentRef={additionalAttachmentRef}
                        setAttachInvoiceLoading={setAttachInvoiceLoading}
                        //   setAttchmentFile_UI={setAttchmentFile_UI}
                        //   attachmentFile_UI={attachmentFile_UI}
                        physicalOrEInvoice={physicalOrEInvoice}
                        changeHandler={changeHandler}
                        alignForAttachment={true}
                        setAttachmentURLList={setAttachmentURLList}
                        attachmentURLList={attachmentURLList}
                        setAttachmentURL={setAttachmentURL}
                        showAttachmentsHandler={showAttachmentsHandler}
                        setOpenInvalidWarningDate={setOpenInvalidWarningDate}
                        setInvalidWarningDateState={setInvalidWarningDateState}
                        multipleData={multipleData}
                        edit={false}
                        hide={false}
                        setSuccessMessage={setSuccessMessage}
                      />
                    )}
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={6}
                    style={{ paddingLeft: "10px" }}
                  >
                    <Heading title="Attachment Preview">
                      <span>
                        {attachmentURL != ""
                          ? attachmentURL == formState?.invoice_attachment
                            ? " (Invoice Attachmnets)"
                            : "(Additional Documents)"
                          : null}
                      </span>
                    </Heading>
                    {/* <Typography
          variant="h5"
          component="h2"
          style={{ paddingLeft: "7px", marginTop: "20px" }}
        >
          Attachment Preview
        </Typography> */}

                    <AttachmentsCover
                      attachmentURLList={attachmentURLList}
                      setAttachmentURLList={setAttachmentURLList}
                      attachmentURL={attachmentURL}
                      setAttachmentURL={setAttachmentURL}
                    />
                  </Grid>
                </Grid>
                {(formState?.isPCDV && formState?.invoice_No) && (
                  <>
                    <Heading title="Expense Detail" />

                    <ExpenseDetailTable formState={formState} />
                  </>
                )}
                <form onSubmit={confirmHandler} style={{ marginTop: "50px" }}>
                  {/* Check boxes */}
                  {!newFormState?.isHR && (
                    <InvoiceCheckboxes
                      formState={newFormState}
                      setFormState={setNewFormState}
                      selectedRole="IP"
                      disabled={
                        status === "SendToIPFromSupervisor" ||
                        status === "SendToReviewerFromSupervisor"
                          ? true
                          : false
                      }
                    />
                  )}

                  <Grid container>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      {formState?.invoice_No && (
                        <InvoiceTextField
                        formState= {formState}
                          newFormState={newFormState}
                          setNewFormState={setNewFormState}
                          selectedRole="IP"
                          disabled={false}
                          poBasedState={poBasedState}
                          showVendorAndPO_NumberForImport={
                            showVendorAndPO_NumberForImport
                          }
                          showVendorCodeForImport={showVendorCodeForImport}
                          invoice_attachmentRef={invoice_attachmentRef}
                          additionalAttachmentRef={additionalAttachmentRef}
                          setAttachInvoiceLoading={setAttachInvoiceLoading}
                          // setAttchmentFile_UI={setAttchmentFile_UI}
                          // attachmentFile_UI={attachmentFile_UI}
                          physicalOrEInvoice={physicalOrEInvoice}
                          changeHandler={changeHandler}
                          alignForAttachment={false}
                          setAttachmentURLList={setAttachmentURLList}
                          attachmentURLList={attachmentURLList}
                          setAttachmentURL={setAttachmentURL}
                          showAttachmentsHandler={showAttachmentsHandler}
                          setOpenInvalidWarningDate={setOpenInvalidWarningDate}
                          setInvalidWarningDateState={
                            setInvalidWarningDateState
                          }
                          multipleData={multipleData}
                          invoicePayload={invoicePayload}
                          // edit={true}
                          hide={true}
                          setSuccessMessage={setSuccessMessage}
                        />
                      )}
                    </Grid>
                  </Grid>

                  {
                    // !formState.isImport &&
                    // !formState.isPCDV &&
                    // formState?.pO_Based &&
                      !formState?.isLogistics &&
                      !formState?.isHR && (
                        <PaymentDetail
                          formState={newFormState}
                          setFormState={setNewFormState}
                          multipleData={multipleData}
                          setOpenInvalidWarningDate={setOpenInvalidWarningDate}
                          setInvalidWarningDateState={
                            setInvalidWarningDateState
                          }
                          disabled={true}
                          // disabled={
                          //   user.Location === "1"
                          //     ? false
                          //     : status === "SendToIPFromSupervisor"
                          //     ? true
                          //     : true
                          // } //this is set for MPAS user because payment detail enable for MPAS user only
                        />
                      )
                  }

                  {/* Tax  */}
                  {/* here is for des invoice to hide it */}
                  {/* {!formState.pO_Based && formState.skipTaxStep ? (
            ""
          ) : ( */}
                  {formState.invoice_Type !== "DES" &&
                    formState.invoice_Type !== "ERF" &&
                    formState.invoice_Type !== "FER" &&
                    !formState.isHR &&
                    !formState.isPCDV && (
                      <div style={{ marginTop: "20px" }} ref={errorMessageRef}>
                        <Heading title="Tax" />
                        {newFormState?.invoice_No && (
                          <TaxDetail
                            formState={newFormState}
                            setFormState={setNewFormState}
                            invoice_Amount={
                              newFormState?.pO_Based && formState?.skipTaxStep
                                ? PO_InvoiceAmountforTax
                                  ? PO_InvoiceAmountforTax
                                  : newFormState.invoice_Amount
                                : newFormState.invoice_Amount
                            }
                            saletaxcode={true}
                            disabled={
                              // formState?.pO_Based && formState?.pO_No && !formState?.isImport
                              //   ? !formState?.skipTaxStep
                              //   : false
                              commentsList[commentsList?.length - 1]
                                ?.ActivityName == "Tax Team" ||
                              edit === "false" ||
                              status === "SendToIPFromSupervisor" ||
                              status === "SendToReviewerFromSupervisor"
                                ? true
                                : formState?.isImport
                                ? false
                                : formState?.isPCDV
                                ? false
                                : !formState?.skipTaxStep
                            }
                          />
                        )}
                        {/* 
             {formState.isImport ? (
               <TaxTable
                 formState={newFormState}
                 setFormState={setNewFormState}
                 invoice_Amount={formState.invoice_Amount}
                 invoicePayload={invoicePayload}
                 edit={edit}
                 isProceed={!newFormState?.isReturn}
               />
             ) : (
               <TaxTable
                 formState={newFormState}
                 setFormState={setNewFormState}
                 invoice_Amount={formState.invoice_Amount}
                 invoicePayload={invoicePayload}
                 edit={edit}
                 isProceed={!newFormState?.isReturn}
               />
             )} */}
                        {ErrorMessageForAmount && (
                          <Grid container spacing={0}>
                            <Grid item>
                              <Error
                                titleAccess="Error"
                                className={classes.asterisk}
                                fontSize="small"
                              />{" "}
                            </Grid>
                            <Grid item>
                              <Typography className={classes.asterisk} ml={1}>
                                {" "}
                                {ErrorMessageForAmount}
                              </Typography>
                            </Grid>
                          </Grid>
                        )}
                        {commentsList[commentsList?.length - 1]?.ActivityName ==
                          "Tax Team" && (
                          <TaxTable
                            formState={newFormState}
                            setFormState={setNewFormState}
                            tempSetFormState={setFormState}
                            invoicePayload={invoicePayload}
                            disabled={true}
                            // invoiceTaxDetail_forImport_Inv={invoiceTaxDetail}
                            // setInvoiceTaxDetail_forImport_Inv={setInvoiceTaxDetail}
                          />
                        )}
                        {newFormState?.invoice_No &&
                          !formState?.isHR &&
                          commentsList[commentsList?.length - 1]
                            ?.ActivityName !== "Tax Team" && (
                            <TaxTableV2
                              formState={newFormState}
                              setFormState={setNewFormState}
                              invoice_Amount={formState.invoice_Amount}
                              invoicePayload={invoicePayload}
                              edit={
                                // edit === "false"
                                //   ? false
                                //   : formState?.pO_Based &&
                                //     formState?.pO_No &&
                                //     !formState?.isImport
                                //   ? formState?.skipTaxStep
                                //   : true
                                edit === "false"
                                  ? true
                                  : formState?.isImport
                                  ? true
                                  : formState?.isPCDV
                                  ? true
                                  : formState?.skipTaxStep
                              }
                              isProceed={false}
                              show={
                                edit === "false"
                                  ? false
                                  : formState?.isImport
                                  ? false
                                  : !formState?.skipTaxStep
                              }
                              setTaxErrorMsg={setTaxErrorMsg}
                              taxErrorMsg={taxErrorMsg}
                            />
                          )}
                        {!formState?.isHR ? (
                          <VendorTaxTable
                            formState={newFormState}
                            setFormState={setNewFormState}
                          />
                        ) : null}
                      </div>
                    )}
                  {formState.invoice_Type === "ERF" && (
                    <ExpenseDetail multipleData={multipleData} />
                  )}
                  {formState.invoice_Type === "FER" && (
                    <>
                      <FER_Fuel_General_Allowance multipleData={multipleData} />
                      {/* <FER_General multipleData={multipleData}/>
          <FER_Allowance multipleData={multipleData}/> */}
                    </>
                  )}
                  {/* )} */}
                  <span></span>
                  {
                   !(status === "SendToIPFromSupervisor" && importPaymentDetail?.invoice_Payment_Details?.some(
                       (item) => item.postingKey === "29"))&&
                  formState?.isHR &&
                  formState.invoice_Type !== "ERF" &&
                  formState.invoice_Type !== "FER" ? (
                    <div style={{ marginTop: "20px" }}>
                      <Heading title="G/L Account" />
                      <GL_Table_HR_ProcessInvoiceV2
                        formState={newFormState}
                        setFormState={setNewFormState}
                        setGLAccountTotal={setGLAccountTotal}
                        importPaymentDetail={importPaymentDetail}
                        disabled={
                          status === "SendToIPFromSupervisor" ||
                          status === "SendToReviewerFromSupervisor"
                            ? true
                            : false
                        }
                        setImportPaymentDetail={setImportPaymentDetail}
                        setErrorMessageForAmount={setErrorMessageForAmount}
                      />
                    </div>
                  ) : (
  !(status === "SendToIPFromSupervisor" &&
    importPaymentDetail?.invoice_Payment_Details?.some(
      (item) => item.postingKey === "29"
    )) &&
  formState.invoice_Type !== "ERF" &&
  formState.invoice_Type !== "FER" &&
  newFormState.invoice_No && (
    <>
      <div style={{ marginTop: "20px" }}>
        <Heading title="G/L Account" />
        {  newFormState?.invoice_Type === 'Final Settlement - Distributor' ?
                         <GL_Table_V2
                         data={newFormState.invoice_Accounts}
                           formState={newFormState}
                          setFormState={setNewFormState}
                          show={false}
                          reviwerFlag={ true }
                          role={selectedRole}                        /> 
                          
                          
                          :
        <GL_Table_ProcessInvoiceV2
          formState={newFormState}
          setFormState={setNewFormState}
          setGLAccountTotal={setGLAccountTotal}
          importPaymentDetail={importPaymentDetail}
          disabled={
            status === "SendToIPFromSupervisor" ||
            status === "SendToReviewerFromSupervisor"
                 ? true
                 : false
          }
          setImportPaymentDetail={setImportPaymentDetail}
          setErrorMessageForAmount={setErrorMessageForAmount}
        />
}
      </div>

      {formState?.isDeptCordinator && formState?.invoice_Type === "Rent" && (
        <DepartmentCoordinatorRent
          formState={formState}
          setFormState={setFormState}
          show={false}
          reviwerFlag={false}
          role={
            selectedRole?.roleName === "Department Coordinator" &&
            formState.invoice_Type === "Rent"
              ? ""
              : "HR"
          }
        />
      )}
    </>
                    )
                  )}

                  {(formState?.isPCDV) && (
                    <>
                      <GLAccountHistory multipleData={multipleData} />
                    </>
                  )}

                  {formState?.isImport && formState?.pO_Based ? (
                    <>
                      <Po_ImportReference_Table
                        setPOImportReference_Table={setPOImportReference_Table}
                        POImportReference_Table={POImportReference_Table}
                        loading={po_Loading}
                        formState={newFormState}
                        setFormState={setNewFormState}
                        disabled={false}
                      />
                      <PoDetail_Table_Import
                        formState={newFormState}
                        // setSelectedTotal={setSelectedTotal}
                        setSelectedTotal={setTotalGrnAmount}
                        setFormState={setNewFormState}
                        deletee={true}
                        Invoice_id={invoicePayload?.Invoice_id}
                        checkedBox={false}
                        loading={po_Loading}
                        edit={
                          status === "SendToIPFromSupervisor" ? true : false
                        }
                      />
                    </>
                  ) : (
                    <>
                      {formState?.pO_Based &&
                        newFormState?.invoice_No &&
                        !newFormState?.isHR && (
                          <PODetail
                            formState={newFormState}
                            setFormState={setNewFormState}
                            // formState={formState}
                            // setFormState={setFormState}
                            // disabled={newFormState.isImport ? true : false}
                            disabled={
                              status === "SendToIPFromSupervisor" ? true : false
                            }
                            ipUser={true}
                            Invoice_id={invoicePayload?.Invoice_id}
                            setSelectedTotal={setTotalGrnAmount}
                            loading={po_Loading}
                          />
                        )}
                    </>
                  )}

                  {!formState.pO_Based &&
                    newFormState?.invoice_No &&
                    formState.invoice_Type !== "ERF" &&
                    formState.invoice_Type !== "FER" && (
                      <PaymentImport
                        formState={importPaymentDetail}
                        vendor={{
                          name: formState?.vendor_Name || "",
                          code: formState?.vendor_Code || "",
                        }}
                        inv_amount={formState?.invoice_Amount}
                        invoiceData={{
                          taxCode:
                            newFormState?.salesTaxCode?.split(" - ")[0] || "",
                          taxAmount: Number(newFormState?.salesTaxAmount),
                          GLInvoice_Accounts: newFormState?.invoice_Accounts,
                          isPCDV: newFormState?.isPCDV,
                          vendor_Code: newFormState?.vendor_Code,
                          vendor_Name: newFormState?.vendor_Name,
                        }}
                        setImportPaymentDetail={setImportPaymentDetail}
                        setFormState={setNewFormState}
                        formState1={newFormState}
                        multipleData={multipleData}
                        edit={edit !== "true"}
                        disable={false}
                        // description={newFormState.invoice_Desc}
                      />
                    )}

                     {/* {(
  formState?.rtbId
) && (
  <Grid container spacing={2} marginY={2}>
    <Grid item xs={12}>
      <RTBLineItems_Table 
      formState={formState}
      setFormState={setFormState}
      setSelectedTotal={() => {}}
      selectedRole={selectedRole}
      />
    </Grid>
  </Grid>
)} */}
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <CommentHistory
                      commentsList={commentsList}
                      commentsLoading={commentsLoading}
                    />
                  </Grid>

                  {/* clearing detail */}
                  {formState.isImport && formState.demandType !== "Deposit" && (
                    <Grid container style={{ margin: "20px 0px" }}>
                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <Typography variant="h4">
                          <Heading title="Clearing Detail" />
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={12} md={3} lg={3} mt={1}>
                        <Typography style={{ color: "black" }}>
                          {!newFormState?.isReturn ? (
                            <span className={classes.asterisk}>*</span>
                          ) : null}
                          First Clearing Text:{" "}
                        </Typography>
                        <TextField
                          fullWidth
                          size="small"
                          sx={{
                            // width: "70%",
                            "& legend": { display: "none" },
                            "& fieldset": { top: 0 },
                          }}
                          id="outlined-basic"
                          variant="outlined"
                          name="firstClearText"
                          value={newFormState?.firstClearText}
                          onChange={changeHandler}
                          required={!newFormState?.isReturn}
                          disabled={
                            status === "SendToIPFromSupervisor" ||
                            status === "SendToReviewerFromSupervisor"
                              ? true
                              : false
                          }
                        />
                      </Grid>
                      {formState?.isPSID && (
                        <Grid item xs={12} sm={12} md={3} lg={3} mt={1} ml={1}>
                          <Typography style={{ color: "black" }}>
                            {formState?.isPSID && !newFormState?.isReturn ? (
                              <span className={classes.asterisk}>*</span>
                            ) : null}
                            Second Clearing Text:{" "}
                          </Typography>
                          <TextField
                            fullWidth
                            size="small"
                            sx={{
                              // width: "70%",
                              "& legend": { display: "none" },
                              "& fieldset": { top: 0 },
                            }}
                            id="outlined-basic"
                            variant="outlined"
                            name="secondClearText"
                            value={newFormState?.secondClearText}
                            onChange={changeHandler}
                            required={
                              formState?.isPSID && !newFormState?.isReturn
                            }
                            disabled={
                              status === "SendToIPFromSupervisor" ||
                              status === "SendToReviewerFromSupervisor"
                                ? true
                                : false
                            }
                          />
                        </Grid>
                      )}
                    </Grid>
                  )}
                  {(formState.isImport &&
                    formState.demandType !== "Deposit" &&
                    formState?.invoice_No) ||
                  (formState?.isHR &&
                    formState.invoiceCategory.includes(
                      "Final Settlement – Death case"
                    ) &&
                    formState?.invoice_No) ? (
                    <Vendor_Table
                      formState={newFormState}
                      setFormState={setNewFormState}
                      disablePostToSap = {disablePostToSap}
                      disabled={
                        status === "SendToIPFromSupervisor" ||
                        status === "SendToReviewerFromSupervisor"
                          ? true
                          : false
                      }
                      required={!newFormState?.isReturn}
                      vendorList={vendorList}
                      setVendorList={setVendorList}
                      setDisablePostToSap = {setDisablePostToSap}
                    />
                  ) : (
                    ""
                  )}
                  <Grid container style={{ margin: "20px 0px" }}>
                    <Grid item xs={12} sm={12} md={3} lg={12}>
                      <Typography style={{ color: "black" }}>
                        Comments:
                        {/* <span className={classes.asterisk}>*</span> */}
                      </Typography>
                      <TextField
                        fullWidth
                        multiline
                        // rows={2}
                        maxRows={4}
                        // size="small"
                        sx={{
                          // width: "70%",
                          "& legend": { display: "none" },
                          "& fieldset": { top: 0 },
                        }}
                        id="outlined-basic"
                        variant="outlined"
                        name="comments"
                        // required={statusForPayload === "SendToIRFromIP" ? true : false}

                        required={newFormState?.isReturn}
                        value={newFormState.comments}
                        onChange={changeHandler}
                      />
                    </Grid>
                  </Grid>

                  {/* 3 way check */}

                  {!formState?.pO_Based &&
                    formState.invoice_Type !== "ERF" &&
                    formState.invoice_Type !== "FER" && (
                      <Grid
                        container
                        style={{
                          borderRadius: "4px",
                          margin: "5px 0px 0px 0px ",
                          padding: "5px 27px 20px 10px",
                          backgroundColor: "#EBEDEF",
                        }}
                        xs={12}
                        sm={12}
                        md={12}
                        lg={8}
                        spacing={2}
                      >
                        <Grid item xs={12} sm={12} md={12} lg={4}>
                          {
                            <Typography
                              style={{
                                color: "#fff",
                                borderRadius: "2px",

                                padding: "14px",

                                backgroundColor: `${
                                  addZeroes(
                                    parseFloat(debitBalance).toFixed(2)
                                  ) ===
                                  addZeroes(
                                    parseFloat(creditBalance).toFixed(2)
                                  )
                                    ? "#4caf50"
                                    : "#fc4b6c"
                                }`,
                              }}
                            >
                              Debit: {debitBalance}
                            </Typography>
                          }
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={4}>
                          {
                            <Typography
                              style={{
                                color: "#fff",
                                borderRadius: "2px",
                                padding: "14px",

                                // backgroundColor: "#4caf50",
                                backgroundColor: "#F7931E",
                              }}
                            >
                              Credit : {creditBalance}
                            </Typography>
                          }
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={4}>
                          {
                            <Typography
                              style={{
                                color: "#fff",

                                borderRadius: "2px",
                                padding: "14px",

                                // backgroundColor: "#4caf50",
                                backgroundColor: "#888888",
                              }}
                            >
                              Balance:{" "}
                              {addZeroes(
                                Number(debitBalance) - Number(creditBalance)
                              )}
                              {/* Balance: {(debitBalance - creditBalance).toFixed(3)} */}
                            </Typography>
                          }
                        </Grid>
                      </Grid>
                    )}
                  {formState?.pO_Based && (
                    <Grid
                      container
                      xs={12}
                      sm={12}
                      md={6}
                      lg={6}
                      spacing={2}
                      style={{
                        margin: "5px 0px 0px 0px ",
                        padding: "5px 27px 20px 10px",
                        borderRadius: "4px",
                        backgroundColor: "#EBEDEF",
                      }}
                    >
                      <Grid item xs={12} sm={12} md={6} lg={6}>
                        {
                          <Typography
                            style={{
                              borderRadius: "2px",
                              color: "white",
                              padding: "14px",
                              // backgroundColor: `${balance === 0 ? "black" : "#fc4b6c"}`,
                              backgroundColor: `${
                                balance === 0 ? "black" : "#888888"
                              }`,
                            }}
                          >
                            Balance: {addZeroes(balance)}
                            {/* {parseFloat(gLAccountTotal|| 0) - formState?.invoice_Amount} */}
                          </Typography>
                        }
                      </Grid>
                      <Grid item xs={12} sm={12} md={6} lg={6}>
                        {
                          <Typography
                            style={{
                              borderRadius: "2px",
                              color: "white",
                              padding: "14px",

                              backgroundColor: "#4caf50",
                            }}
                          >
                            GRN Amount: {addZeroes(totalGrnAmount)}
                          </Typography>
                        }
                      </Grid>
                    </Grid>
                  )}
                  {(selectedRole?.roleName === "IP" ||
                    selectedRole?.roleName === "Reviewer") && (
                    <Grid container>
                      {(Post && allowToProceed) && (
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          md={12}
                          lg={12}
                          style={{ marginTop: "10px" }}
                        >
                          {!formState?.pO_Based &&
                            formState?.dept_coordinator &&
                            !formState?.isPCDV &&
                            !formState?.isLogistics &&
                            status !== "SendToIPFromSupervisor" &&
                            status !== "SendToReviewerFromSupervisor" && (
                              <Button
                                style={{
                                  margin: "2px",
                                  backgroundColor: "black",
                                  color: "white",
                                }}
                                variant="contained"
                                color="success"
                                type="submit"
                                onClick={() => {
                                  setNewFormState((newFormState) => ({
                                    ...newFormState,
                                    isReturn: true,
                                  }));
                                  setConfirmationMessage(
                                    "Are you sure to send invoice to Department Coordinator"
                                  );
                                  setStatusForPayload(
                                    "SendToDeptCoordinatorFromIP"
                                  );
                                }}
                              >
                                Return to Department Coordinator
                              </Button>
                            )}
                          {formState.invoice_Type !== "ERF" &&
                            formState.invoice_Type !== "FER" &&
                            status !== "SendToIPFromSupervisor" &&
                            status !== "SendToReviewerFromSupervisor" &&
                            !formState.isDeptCordinator && (
                              <Button
                                style={{
                                  margin: "2px",
                                  backgroundColor: "black",
                                  color: "white",
                                }}
                                variant="contained"
                                color="inherit"
                                type="submit"
                                onClick={() => {
                                  setReviewer('')
                                  setNewFormState((newFormState) => ({
                                    ...newFormState,
                                    isReturn: true,
                                  }));
                                  setConfirmationMessage(
                                    `Are you sure to send invoice to${" "}${
                                      formState?.isPCDV
                                        ? "Initiator"
                                        : formState?.isImport
                                        ? "Import"
                                        : "Invoice Receiver"
                                    }`
                                  );
                                  setStatusForPayload(
                                    formState?.isImport
                                      ? "SendToImportFromIP"
                                      : formState?.isPCDV
                                      ? "SendToEfdvInitiatorFromIP"
                                      : (formState?.invoiceCategory ===
                                          "Employee Advance" ||
                                          formState?.invoiceCategory ===
                                            "Employee Loan") &&
                                        formState?.lineManager
                                      ? "SendToLineManagerFromIP"
                                      : formState.invoiceCategory ===
                                          "Others" &&
                                        (formState?.directorHR ||
                                          formState?.sharedServices) &&
                                        formState?.lineManager
                                      ? "SendToLineManagerFromIP"
                                      : formState?.directorHR
                                      ? "SendToDirectorHRFromIP"
                                      : formState?.isHR
                                      ? "SendToHrFromIP"
                                      : "SendToIRFromIP"
                                  );
                                }}
                              >
                                {formState?.isPCDV
                                  ? "Return to Initiator"
                                  : formState?.isImport
                                  ? "Return to Import"
                                  : (formState?.invoiceCategory ===
                                      "Employee Advance" ||
                                      formState?.invoiceCategory ===
                                        "Employee Loan") &&
                                    formState?.lineManager
                                  ? "Return to Line Manager"
                                  : formState.invoiceCategory === "Others" &&
                                    (formState?.directorHR ||
                                      formState?.sharedServices) &&
                                    formState?.lineManager
                                  ? "Return to Line Manager"
                                  : formState?.directorHR
                                  ? "Return to Director HR"
                                  : formState?.isHR
                                  ? "Return to HR"
                                  : "Return to Invoice Receiver"}
                              </Button>
                            )}

                               {(status=='SendToIP' && roleName=='IP') &&  <Button
                                style={{
                                  margin: "2px",
                                  backgroundColor: "black",
                                  color: "white",
                                  // display: `${formState.skipTaxStep}` === "true" ? "none": ""
                                }}
                                variant="contained"
                                type="submit"
                                onClick={() => { 
                                  setNewFormState((newFormState) => ({
                                    ...newFormState,
                                    isReturn: true,
                                  })); 
                                 newFormState.comments!=="" && setReviewer('OK')
                                 console.log("Reviewer")                         
                                }}
                              >
                                Send to Reviewer
                              </Button>}
                          {!formState?.isVPPayment &&
                            !formState.isImport &&
                            !formState?.isPCDV &&
                            formState.invoice_Type !== "ERF" &&
                            formState.invoice_Type !== "FER" &&
                            formState.invoice_Type !== "Credit Note" &&
                            status !== "SendToIPFromSupervisor" &&
                            !formState?.isHR &&
                            status !== "SendToReviewerFromSupervisor" && (
                              <Button
                                style={{
                                  margin: "2px",
                                  backgroundColor: "black",
                                  color: "white",
                                  // display: `${formState.skipTaxStep}` === "true" ? "none": ""
                                }}
                                variant="contained"
                                type="submit"
                                onClick={() => {
                                  if (formState?.skipTaxStep) {
                                    setStatusForPayload("SendToTaxTeamFromIP");
                                    setNewFormState((newFormState) => ({
                                      ...newFormState,
                                      isReturn: true,
                                    }));
                                    formState.comments !== "" &&
                                      formState?.skipTaxStep &&
                                      setOpenTaxModal(true);
                                  } else {
                                    setNewFormState((newFormState) => ({
                                      ...newFormState,
                                      isReturn: true,
                                    }));
                                    setConfirmationMessage(
                                      "Are you sure to send invoice to Tax Team"
                                    );
                                    setStatusForPayload("SendToTaxTeamFromIP");
                                  }
                                }}
                              >
                                Return to Tax Team
                              </Button>
                            )}
                          {formState.invoice_Type === "ERF" ||
                          formState.invoice_Type === "FER" ? (
                            <Button
                              style={{ margin: "2px" }}
                              variant="contained"
                              color="secondary"
                              type="submit"
                              onClick={() => {
                                setNewFormState((newFormState) => ({
                                  ...newFormState,
                                  isReturn: false,
                                }));
                                setStatusForPayload("SendToSupervisor");
                              }}
                              disabled={false}
                            >
                              {status === "SendToIPFromSupervisor" ||
                              status === "SendToReviewerFromSupervisor"
                                ? "Proceed"
                                : " Post to SAP"}
                            </Button>
                          ) : (
                            <Button
                              style={{ margin: "2px" }}
                              variant="contained"
                              color="secondary"
                              type="submit"
                              onClick={() => {
                                setNewFormState((newFormState) => ({
                                  ...newFormState,
                                  isReturn: false,
                                }));
                                setStatusForPayload("SendToSupervisor");
                              }}
                              disabled={
                               (formState.isImport &&
                    formState.demandType !== "Deposit" ) ?
                    formState?.pO_Based
                    ? (balance.toFixed(2) !== zero.toFixed(2) &&
                    balance.toFixed(2) !== "-0.00" ) ? balance.toFixed(2) !== zero.toFixed(2) &&
                    balance.toFixed(2) !== "-0.00"  :  disablePostToSap
                    : (balance.toFixed(2) !== zero.toFixed(2) &&
                    balance.toFixed(2) !== "-0.00" ) ? balance.toFixed(2) !== zero.toFixed(2) &&
                    balance.toFixed(2) !== "-0.00"  :  disablePostToSap :

                   ( formState?.pO_Based
                    ? balance.toFixed(2) !== zero.toFixed(2) &&
                      balance.toFixed(2) !== "-0.00"
                    : balance.toFixed(2) !== zero.toFixed(2) &&
                      balance.toFixed(2) !== "-0.00")
                              }
                            >
                              {status === "SendToIPFromSupervisor" ||
                              status === "SendToReviewerFromSupervisor"
                                ? "Proceed"
                                : " Post to SAP"}
                            </Button>
                          )}
                        </Grid>
                      )}
                    </Grid>
                  )}
                </form>
              </CardBody>
            </>
          )}
          {openInvalidWarningDate && (
            <OldDateWarning
              open={openInvalidWarningDate}
              close={() => setOpenInvalidWarningDate(false)}
              InvalidWarningDateState={InvalidWarningDateState}
            />
          )}
          {openTaxModal && (
            <TaxTeamModal
              open={openTaxModal}
              close={() => setOpenTaxModal(false)}
              newFormState={newFormState}
              setNewFormState={setNewFormState}
              statusForPayload={statusForPayload}
              setStatusForPayload={setStatusForPayload}
              Invoice_Id={invoicePayload.Invoice_id}
              setSuccessMessage={setSuccessMessage}
              setErrorMessage={setErrorMessage}
              setLoading={setAttachInvoiceLoading}
              loading={attachInvoiceLoading}
            />
          )}
            {reviewerModal && (
            <ReviewerModal
              open={reviewerModal}
              close={() => setReviewerModal(false)}
              newFormState={newFormState}
                  setNewFormState={setNewFormState}
              statusForPayload={statusForPayload}
              setStatusForPayload={setStatusForPayload}
              Invoice_Id={invoicePayload.Invoice_id}
              setSuccessMessage={setSuccessMessage}
              setErrorMessage={setErrorMessage}
              setLoading={setAttachInvoiceLoading}
              loading={attachInvoiceLoading}
            />
          )}
          {confirmationModal && (
            <ConfirmationModal
              open={confirmationModal}
              close={() => setConfirmationModal(false)}
              message={confirmationMessage}
              // submit={() =>
              //   changeInvoiceStatus(
              //     formState.invoice_Id,
              //     statusForPayload,
              //     setConfirmationModal,
              //     setAttachInvoiceLoading,
              //     setSuccessMessage,
              //     setErrorMessage,
              //     navigate,
              //     newFormState.comments
              //   )
              // }
              submit={submitHandler}
              loading={attachInvoiceLoading}
            />
          )}

          {openInvoiceGuideLine && (
            <InvoiceGuideLine
              open={openInvoiceGuideLine}
              close={setOpenInvoiceGuideLine}
            />
          )}
          {successMessage && (
            <CustomSnackbar
              open={successMessage !== ""}
              message={successMessage}
              handleClose={() => setSuccessMessage("")}
              variant="success"
            />
          )}
          {errorMessage && (
            <>
              {" "}
              <Grid container spacing={0}>
                <Grid item>
                  <Error
                    titleAccess="Error"
                    className={classes.asterisk}
                    fontSize="small"
                  />{" "}
                </Grid>
                <Grid item>
                  <Typography className={classes.asterisk} ml={1}>
                    {" "}
                    {errorMessage}
                  </Typography>
                </Grid>
              </Grid>
            </>
          )}
          {openWarningBox && (
            <WarningBox
              open={openWarningBox}
              close={() => setOpenWarningBox(false)}
              submit={submitHandler}
              message="Are you sure to Post the invoice to SAP"
            />
          )}
          {alertMessage && (
            <POAlertDialog
              setAlertMessage={setAlertMessage}
              message={attachError ? attachError : docError}
              setErrAlertMessage={() => {}}
            />
          )}
          {specialCharError && (
            <POAlertDialog
              setAlertMessage={setSpecialCharError}
              message="Invoice Decription should not contain any Special character"
              setErrAlertMessage={() => {}}
            />
          )}
        </Card>
      {/* ) : (
        <PageNotFound />
      )} */}
    </div>
  );
};

export default ProcessInvoice;
